import { BaseContainer } from './BaseContainer';
import { BreezeSingleStarIcon } from 'foundations-assets/icons/components/BreezeSingleStarIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const BreezeSvg = () => {
  return /*#__PURE__*/_jsx(BaseContainer, {
    $svgSize: '60%',
    children: /*#__PURE__*/_jsx(BreezeSingleStarIcon, {})
  });
};